import React from 'react'
import { FormattedMessage } from 'react-intl'

const WarningModalLink = () => {
  return (
    <FormattedMessage
      id='Homeowner.estimatedValue.avmAndDisclosureLearnMore'
      defaultMessage='Learn more about this.'
    />
  )
}

export default WarningModalLink
